import { useEffect, useCallback, useMemo } from 'react';
import { useParams, useNavigate, useOutletContext, useLocation } from 'react-router-dom';
import { InvoiceList } from '@/components/invoices/InvoiceList';
import type { AppShellContext } from '@/components/layout/AppShell';

export function InvoiceListPage() {
  const { nip } = useParams<{ nip: string }>();
  const { companyName } = useOutletContext<AppShellContext>();
  const navigate = useNavigate();
  const location = useLocation();

  const handleInvoiceSelect = useCallback(
    (invoiceId: string) => {
      navigate(`/${nip}/invoices/${invoiceId}`, {
        state: { listSearch: location.search },
      });
    },
    [nip, navigate, location.search],
  );

  // Handle refetch trigger from InvoiceDetailPage
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const refetchKey = useMemo(() => location.state?.refetch ? Date.now() : undefined, [location.state?.refetch]);

  useEffect(() => {
    if (location.state?.refetch) {
      // Clear the state so refreshing the page doesn't re-trigger, but preserve search params
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, location.search, navigate]);

  return (
    <InvoiceList
      companyNip={nip || ''}
      companyName={companyName}
      onInvoiceSelect={handleInvoiceSelect}
      refreshKey={refetchKey}
    />
  );
}
